import { hc, type ClientRequestOptions } from "hono/client";
import { createAuthClient } from "better-auth/react";
import type {
  EditorRouter,
  Auth,
  RendererRouter,
  AuthRouter,
  AdminRouter,
} from "@op/api";
import {
  apiKeyClient,
  customSessionClient,
  magicLinkClient,
} from "better-auth/client/plugins";
export type * from "@op/api/db/types";

export type EditorClient = ReturnType<typeof hc<EditorRouter>>;

export function makeEditorClient(
  baseUrl: string,
  options?: ClientRequestOptions
): EditorClient {
  return hc<EditorRouter>(baseUrl, {
    ...options,
    fetch: ((input: string | URL | Request, init?: RequestInit) =>
      fetch(input, {
        ...init,
        credentials: "include",
      })) as NonNullable<ClientRequestOptions["fetch"]>,
  });
}

export type RendererClient = ReturnType<typeof hc<RendererRouter>>;

export function makeRendererClient(
  baseUrl: string,
  apiKey: string
): RendererClient {
  return hc<RendererRouter>(baseUrl, {
    fetch: ((input: string | URL | Request, init?: RequestInit) =>
      fetch(input, {
        ...init,
        headers: {
          ...init?.headers,
          "x-api-key": apiKey,
        },
      })) as NonNullable<ClientRequestOptions["fetch"]>,
  });
}

export type AuthRouterClient = ReturnType<typeof hc<AuthRouter>>;

export function makeAuthRouterClient(
  baseUrl: string,
  options?: ClientRequestOptions
): AuthRouterClient {
  return hc<AuthRouter>(baseUrl, {
    ...options,
    fetch: ((input: string | URL | Request, init?: RequestInit) =>
      fetch(input, {
        ...init,
        credentials: "include",
      })) as NonNullable<ClientRequestOptions["fetch"]>,
  });
}

export type AdminRouterClient = ReturnType<typeof hc<AdminRouter>>;

export function makeAdminRouterClient(
  baseUrl: string,
  options?: ClientRequestOptions
): AdminRouterClient {
  return hc<AdminRouter>(baseUrl, {
    ...options,
    fetch: ((input: string | URL | Request, init?: RequestInit) =>
      fetch(input, {
        ...init,
        credentials: "include",
      })) as NonNullable<ClientRequestOptions["fetch"]>,
  });
}

export const makeAuthClient = (baseUrl: string) =>
  createAuthClient({
    baseURL: baseUrl,
    plugins: [customSessionClient<Auth>(), magicLinkClient(), apiKeyClient()],
  });
